import { Reducer } from 'react';

export type State = {
  // eslint-disable-next-line
  trackingService: any;
};

// eslint-disable-next-line no-shadow
export enum ActionTypes {
  // eslint-disable-next-line no-unused-vars
  setTrackingService,
}

export type Action = {
  type: ActionTypes;
  // eslint-disable-next-line
  payload: any;
};

const reducer: Reducer<State, Action> = (state: State, action: Action) => {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.setTrackingService:
      return { ...state, trackingService: payload };

    default:
      throw new Error(`Invalid action type: ${type}`);
  }
};

export default reducer;
